<template>
  <div class="lang-cnt">
     <span>Paciente</span>
     <span>Empresas</span>
     <span>Opensalud4all</span>
    <!-- <span :class="{'active': isActive('es')}" @click="$i18nHelpers.changeLang('es')">ES</span>
    <span :class="{'active': isActive('en')}" @click="$i18nHelpers.changeLang('en')">EN</span> -->
  </div>
</template>

<script>
export default {
  name: 'NavProfessionalButtons',
  data () {
    return {
      lang: this.$i18n.locale
    }
  },
  methods: {
    isActive (lang) {
      return this.lang === lang
    }
  }
}
</script>

<style scoped lang="scss">
  .lang-cnt {
    color: $blue;
    font-weight: bold;
    transition: all 0.3s ease;

    span {
      cursor: pointer;
        margin-right: 1rem;
      &:is(:last-child) {
        margin-right: 25rem;
      }&:is(:first-child) {
        margin-left: 4rem;
      }
      

      &:hover {
        transition: all 0.3s ease;
        // border-top: 1px solid $blue#{55};
      }

      &.active {
        border-top: 2px solid $blue;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/nav-professional-buttons.vue